import GlobalPrototypes from '@/config/services/globalPrototypes.ts'

export function useHasSlotContent() {
  return {
    hasSlotContent: GlobalPrototypes.hasSlotContent,
  }
}
